import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { COLLAPSED, EXPANDED, verticalCollapse } from '@epicuro-next/ui';
import { getFullShipToAddress } from '@epicuro-next/utilities';
import { Account, Address } from 'graphql-api/gql-api-interfaces';

import { SelectionAccountPayload } from '../../types';

@Component({
  selector: 'epc-selected-accounts',
  templateUrl: './selected-accounts.component.html',
  styleUrls: ['./selected-accounts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [verticalCollapse('45%', '9.25rem', 300)],
  standalone: false,
})
export class SelectedAccountsComponent {
  @Input() public selectedAccounts: Account[] = [];
  @Input() public isAccountAddressReverted = true;

  @Output()
  public toggleAccountSelection = new EventEmitter<SelectionAccountPayload>();

  @HostBinding('@verticalCollapse')
  public get collapseState() {
    return this.isOpen ? EXPANDED : COLLAPSED;
  }

  @HostBinding('class.isOpen')
  public isOpen = false;

  public getFullShipToAddress(address: Address) {
    return getFullShipToAddress(address, {
      revertAddress: this.isAccountAddressReverted,
      countryCodePreferred: true,
    });
  }

  public deselectAccount(_: Event, account: Account) {
    this.toggleAccountSelection.emit({
      account,
      isSelected: false,
      isSingleSelection: false,
    });
  }

  public toggleOpen() {
    this.isOpen = !this.isOpen;
  }
}
